import React, { useContext, useEffect, useState } from "react";
import MultiSelect from "../MultiSelect/MultiSelect";
import ReactSelect from "react-select";
import {
  useGetAllSpwsForACatalogueQuery,
  useGetPointingNamesQuery,
} from "../../redux/catalogueService";
import { useParams } from "react-router-dom";
import { useBulkSourceStitchMutation, useGetRefSpwAndSeparationQuery, useUpdateConfigMutation } from "../../redux/pointingSourcesService";
import { AppContext } from "../../context/appContext";
import './SourceStitching.scss';
import { tranformOptionsForRequest, transformOptions } from "../../helperFunc";
const spwOptions = [
  { value: "LSPW_9", label: "LSPW_9" },
  { value: "LSPW_2", label: "LSPW_2" },
];

// function tranformOptionsForRequest(arr) {
//   return arr.map((item) => item.value);
// }
function SourceStitching() {
  const { catalogueMetadataId: catalogueId } = useParams();
  const {data:spwData,isLoading}=useGetAllSpwsForACatalogueQuery({
    base_url:"catalogues",
    id:catalogueId
  })
  const {data:stitchMetadata}=useGetRefSpwAndSeparationQuery(catalogueId);
  const [menuOpen, setIsMenuOpen] = useState({
    pointing: false,
  });
  const { data: pointing_names } = useGetPointingNamesQuery(catalogueId);
  const [optionSelected, setSelected] = useState({
    pointing: [],
    spw: "",
  });
  const [updateConfig]= useUpdateConfigMutation();
  const [separation,setSeparation]=useState(0);
  const [multiselectSortedList, setMultiselectSortedList] = useState([]);
  const [displayOptions, setDisplayOptions] = useState({
    pointing: [],
    spw: "",
  });
  const { showFlyout, toggleLoaderVisibility } = useContext(AppContext);
  const [bulkSourceStitch]=useBulkSourceStitchMutation();
  useEffect(()=>{
    if(!spwData) return;
    setDisplayOptions(prev=>{
      return{
        ...prev,
         spw:transformOptions(spwData?.spws)
      }
    })

  },[spwData])

  useEffect(()=>{
    setSeparation(stitchMetadata?.separation);
    setSelected((prev) => {
      return {
        ...prev,
        spw: {label:stitchMetadata?.spw,value:stitchMetadata?.spw},
      };
    });
  },[stitchMetadata])
  useEffect(() => {
    setDisplayOptions((prev) => {
      return {
        ...prev,
        pointing: pointing_names,
      };
    });
    setMultiselectSortedList(pointing_names);
    setSelected((prev) => {
      return {
        ...prev,
        pointing: pointing_names,
      };
    });
  }, [pointing_names]);

  const handleChange = (selectedItems, items, dropdownName) => {
    setSelected((prev) => {
      return {
        ...prev,
        [dropdownName]: selectedItems,
      };
    });
    const unselectedItems = items.filter(
      (selectedItem) =>
        !selectedItems?.find((item) => item.label === selectedItem.label)
    );

    setMultiselectSortedList([...unselectedItems, ...selectedItems]);
  };

  const handleBlur = (dropdownName) => {
    console.log("blur");
    setDisplayOptions((prev) => {
      return {
        ...prev,
        pointing: multiselectSortedList,
      };
    });
  };
  const onMenuClose = (dropdownName) => {
    handleBlur();
    setIsMenuOpen((prev) => {
      return { ...prev, [dropdownName]: false };
    });
  };

  const onMenuOpen = (dropdownName) => {
    setIsMenuOpen((prev) => {
      return { ...prev, [dropdownName]: true };
    });
  };

  const triggerBulkStitch=async ()=>{
    toggleLoaderVisibility(true);
    const result = await updateConfig({config:{
      is_reference: true,
      separation,
      spw: optionSelected.spw.label
    },catId:catalogueId});
    toggleLoaderVisibility(false);

    if (result?.data) {
        showFlyout(`Config updated`);
        const stitchResult = await bulkSourceStitch({stitchOptions:{pointing_names:tranformOptionsForRequest(optionSelected.pointing)},catId:catalogueId});
        if (stitchResult?.data) {
          showFlyout(
            `Successfully Submitted Stitching Request`
          );
        }
      }
      if(result?.error){
        showFlyout(
          `Request for stitching failed`
        );
      }
  }
  if (!displayOptions.pointing || displayOptions.pointing.length === 0) return;
  return (
    <div className="multi-select-container">
      <div className="multiselect-options">
        <div>
          <label htmlFor="pointing">Pointing</label>
          <MultiSelect
            id="pointing"
            isMulti={true}
            key="pointing_multi_select"
            options={displayOptions["pointing"]}
            onChange={(selected) =>
              handleChange(selected, displayOptions["pointing"], "pointing")
            }
            value={optionSelected["pointing"]}
            isSelectAll={true}
            menuPlacement={"bottom"}
            closeMenuOnSelect={false}
            onBlur={handleBlur}
            tabSelectsValue={false}
            hideSelectedOptions={false}
            backspaceRemovesValue={false}
            blurInputOnSelect={true}
            isClearable
            isSearchable
            onMenuClose={() => onMenuClose("pointing")}
            onMenuOpen={() => onMenuOpen("pointing")}
            // menuIsOpen={true}
            controlShouldRenderValue={!menuOpen["pointing"]}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? "grey" : "red",
              }),
              menubar: (baseStyles, state) => ({
                ...baseStyles,
                width: "auto",
                minWidth: "400px",
              }),
            }}
          />
        </div>
        <div>
          <label htmlFor="spw">SPW</label>
          <ReactSelect
            id={"spw"}
            options={displayOptions["spw"]}
            onChange={(selected) =>
              setSelected((prev) => {
                return {
                  ...prev,
                  spw: selected,
                };
              })
            }
            value={optionSelected["spw"]}
            menuPlacement={"bottom"}
            closeMenuOnSelect={false}
            tabSelectsValue={false}
            hideSelectedOptions={false}
            backspaceRemovesValue={false}
            blurInputOnSelect={true}
            isSearchable
          />

        </div>
        <div className="separation-cont">
            <label htmlFor="separation">Separation</label>
            <input className="separation" id="separation" type="number" value={separation} onChange={(e)=>setSeparation(e.target.value)}></input>
        </div>

      </div>
      <button
        className="bulk-refresh-btn bg-green-button"
        // onClick={() =>
        //   triggerBulkRefresh({
        //     pointing_names: tranformOptionsForRequest(optionSelected.pointing),
        //     separation: optionSelected.band.value,
        //     spw: tranformOptionsForRequest(optionSelected.spw),
        //   })
        // }
        onClick={triggerBulkStitch}
      >
       Stitch Sources
      </button>
    </div>
  );
}

export default SourceStitching;
